import { useIntl } from "react-intl";

const DomainVerificationAndAccountCapture = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.DomainVerificationAndAccountCapture.header",
            defaultMessage: "Domain verification and account capture"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.DomainVerificationAndAccountCapture.content",
            defaultMessage:
                "Domain verification lets an organization admin centrally manage all of the Atlassian accounts that use the company's domain."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
        </>
    );
};

export default DomainVerificationAndAccountCapture;
